// SPDX-License-Identifier: AGPL-3.0-or-later

export const QUICK_SWITCHER_PORTAL_ID = 'quick_switcher-modal-root';
